export { InsureeNew as default } from './insuress-new';
